import * as actions from "../actions";

const initialState = {
  per_page: 10,
  current_page: 1,
  ordering: {
    key: null,
    direction: null,
  },
  current_table: undefined,
  table_data: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.SET_PER_PAGE:
      return {
        ...state,
        per_page: action.per_page,
      };

    case actions.SET_ORDERING:
      return {
        ...state,
        ordering: action.ordering,
      };
    case actions.SET_CURRENT_PAGE:
      return {
        ...state,
        current_page: action.current_page,
      };
    case actions.SET_CURRENT_TABLE:
      /**
       * Ophalen van oude form data of de initiale form dingen pakken
       */
      let newState = {
        ordering: initialState.ordering,
        current_page: initialState.current_page,
      };

      if (state.table_data[action.current_table] !== undefined) {
        newState.ordering = state.table_data[action.current_table].ordering;
        newState.current_page = state.table_data[action.current_table].current_page;
      }

      /**
       * Save current form misschien voor later
       */
      let newTableData = {
        ...state.table_data,
      };

      if (state.current_table !== undefined) {
        newTableData[state.current_table] = {
          current_page: state.current_page,
          ordering: state.ordering,
        };
      }

      /**
       * Reseten van current page en ordering
       */
      return {
        ...state,
        ...newState,
        current_table: action.current_table,
        table_data: newTableData,
      };
    default:
      return state;
  }
};

export default reducer;
